import React from "react";

export const GuestCard = ({ guest }) => (
    <div data-testid={`guest-card-${guest.id}`} className="group">
        <div className="aspect-[3/4] overflow-hidden bg-black/5 mb-5">
            {guest.photo_url ? (
                <img
                    src={guest.photo_url}
                    alt={guest.name}
                    className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-700"
                />
            ) : <div className="w-full h-full bg-black/10" />}
        </div>
        <div className="eyebrow text-[#B8860B] mb-2">{guest.title || "Guest"}</div>
        <h3 className="font-serif text-2xl md:text-3xl tracking-tight mb-3">{guest.name}</h3>
        <p className="text-sm text-black/60 font-light leading-relaxed line-clamp-3">{guest.bio}</p>
    </div>
);
